import { apiClient } from '@/lib/api/client'

export interface TicketRequestSourceEmail {
  subject: string | null
  body: string
  body_html?: string | null
  received_email_id: number
}

export async function getTicketRequestSourceEmail(
  ticketRequestId: number
): Promise<TicketRequestSourceEmail> {
  const { data } = await apiClient.get<{ data: TicketRequestSourceEmail }>(
    `/support/my-request/${ticketRequestId}/source-email`,
    { timeout: 45000 }
  )
  return data.data
}

export async function sendTicketRequestEmail(
  ticketRequestId: number,
  payload: { subject?: string; body: string; cc?: string; to?: string },
  attachments: File[] = []
): Promise<void> {
  const form = new FormData()
  form.append('body', payload.body)
  if (payload.subject?.trim()) form.append('subject', payload.subject.trim())
  if (payload.cc?.trim()) form.append('cc', payload.cc.trim())
  if (payload.to?.trim()) form.append('to', payload.to.trim())
  for (const file of attachments) {
    form.append('attachments[]', file)
  }
  await apiClient.post(`/support/my-request/${ticketRequestId}/send-email`, form)
}
